import React, { useEffect } from "react";
import * as Yup from "yup";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import TopNav from "../../components/TopNav";
import { addToCart } from "../../actions/cart.action";
import { Loading } from "../../utils/helpers/constants";
import ErrorInputComponent from "../../components/ErrorInputComponent";

export default function PaymentBreakdownComponent() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const payload = location.state;

  const {
    cart: { addToCartLoading },
    documentInstruction: { processingFee, processingFeeLoading },
  } = useSelector(({ cartReducer, documentReducer }) => ({
    cart: cartReducer,
    documentInstruction: documentReducer,
  }));

  useEffect(() => {
    console.log({ payload, processingFee });
    if (payload === undefined || processingFee === {}) {
      history.push("/document-processing");
    }
  }, []);

  const validationSchema = Yup.object({
    indemnityAccepted: Yup.boolean()
      .required("Indemnity must be accepted.")
      .oneOf([true], "Indemnity must be accepted."),
    privacyAccepted: Yup.boolean()
      .required("Privacy policy must be accepted.")
      .oneOf([true], "Privacy policy must be accepted."),
  });
  const { handleSubmit, handleChange, errors } = useFormik({
    initialValues: {
      indemnityAccepted: false,
      privacyAccepted: false,
    },
    validationSchema,
    onSubmit(values) {
      payload.indemnityAccepted = values.indemnityAccepted;
      payload.privacyAccepted = values.privacyAccepted;
      const modalText =
        "Your document processing request is successful. Kindly continue";
      dispatch(addToCart(payload, modalText));
    },
  });

  const buttonLoadState = addToCartLoading === Loading.FETCHING;
  const loadState = processingFeeLoading === Loading.FETCHING;

  return (
    <>
      {loadState ? (
        "Loading..."
      ) : (
        <div className="overflow-hidden">
          <div className=" doc_processing_color h-44 px-2 pt-3">
            <TopNav />
            <div className="transcript_header">Document Processing</div>
            <div className="text-lg md:w-2/3">Document payment breakdown</div>
          </div>
          <div className="px-2 md:mx-20 mt-2 md:mt-10">
            <div>
              <h2 className="mb-2 text-lg font-semibold  dark:text-white">
                Payment
              </h2>
              <ul className="space-y-1 max-w-md list-disc list-inside">
                <div className="flex justify-between">
                  <li>Document Fee</li>
                  <span className="gap-auto text-end">
                    {processingFee?.documentFee}
                  </span>
                </div>
                <div className="flex justify-between">
                  <li>Document Pickup Fee</li>
                  <span className="gap-auto text-end">
                    {processingFee?.pickUpFee}
                  </span>
                </div>
                <div className="flex justify-between">
                  <li>Document Delivery Fee</li>
                  <span className="gap-auto text-end">
                    {processingFee?.deliveryFee}
                  </span>
                </div>
              </ul>

              <div className="flex max-w-md justify-between font-semibold text- ">
                <h3 className="dark:text-white">Total</h3>
                <span>{processingFee?.totalFee}</span>
              </div>

              <div className="fle items-center my-5">
                <input
                  id="link-checkbox"
                  type="checkbox"
                  name="indemnityAccepted"
                  onChange={handleChange}
                  className="checkbox-square mr-3 leading-tight focus:ring-green-500 w-full"
                />
                <label
                  htmlFor="link-checkbox"
                  className="ml-1 text-sm dark:text-gray-300"
                >
                  Indemnity: I hereby authorize Landmark University Alumni
                  Association(LUAA) to collect my document on my behalf and
                  undertake to indenmify Landmark University any form of losses
                  or damages arising from the approved name above.
                </label>
                <ErrorInputComponent error={errors.indemnityAccepted} />
              </div>
              <div className="fle items-center my-5">
                <input
                  id="link-checkbox"
                  type="checkbox"
                  name="privacyAccepted"
                  onChange={handleChange}
                  className="checkbox-square mr-3 leading-tight focus:ring-green-500 w-full"
                />
                <label
                  htmlFor="link-checkbox"
                  className="ml-1 text-sm dark:text-gray-300"
                >
                  By submitting this form, I agree to the{" "}
                  <a href="/dashboard/privacy-policy" target="_blank">
                    privacy policy{" "}
                  </a>
                  and{" "}
                  <a href="/dashboard/terms&condition" target="_blank">
                    terms{" "}
                  </a>
                  of use of Landmark University Association.
                </label>
                <ErrorInputComponent error={errors.privacyAccepted} />
              </div>
            </div>
            <div className="flex justify-end gap-2 mx-2">
              <div className="text-right mb-10 mt-10">
                <button
                  onClick={() => history.goBack()}
                  type="submit"
                  className="bg-red-500 text-white px-4 py-2 rounded"
                >
                  {false && (
                    <i className="fa fa-spinner fa-spin icon_class mr-1" />
                  )}
                  Back
                </button>
              </div>

              <div className="text-right mb-10 mt-10 mr-2">
                <button
                  type="submit"
                  className="bg-green-800 text-white px-4 py-2 rounded"
                  onClick={handleSubmit}
                  disabled={buttonLoadState}
                >
                  {buttonLoadState && (
                    <i className="fa fa-spinner fa-spin icon_class" />
                  )}
                  Add to bag
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
